import {
  CoreConfigProvider,
  GlobalAlert,
  HSpinner,
  useChatBotScript,
} from "@ob/core";
import { FC, Suspense, lazy } from "react";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { allowedPaths, defaultPath } from "./app.config";
import { Layout } from "./components";
import { FeedbackPage } from "./pages/FeedbackPage";
import { Root } from "./pages/Root";

const Onboarding = lazy(() => import("./pages/OnBoarding"));
const Status = lazy(() => import("./pages/Status"));
const Resume = lazy(() => import("./pages/Resume"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: (
      <Layout>
        <FeedbackPage />
      </Layout>
    ),
    children: [
      {
        path: "status",
        element: (
          <Suspense fallback={<HSpinner />}>
            <Status />
          </Suspense>
        ),
      },
      {
        path: "resume/:type?",
        element: (
          <Suspense fallback={<HSpinner />}>
            <Resume />
          </Suspense>
        ),
      },
      {
        path: ":type",
        element: (
          <Suspense fallback={<HSpinner />}>
            <Onboarding />
          </Suspense>
        ),
      },
      {
        path: "*",
        element: <Navigate to={defaultPath} replace />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={defaultPath} replace />,
  },
]);

export type AppRoutesProps = {
  appName: string;
  appVersion: string;
};
export const AppRoutes: FC<AppRoutesProps> = ({ appVersion, appName }) => {
  const { endChat, startChat } = useChatBotScript();
  return (
    <CoreConfigProvider
      appName={appName}
      appVersion={appVersion}
      allowedPaths={allowedPaths}
      defaultPath={defaultPath}
      onOpenChatRequest={startChat}
      onCloseChatRequest={endChat}
    >
      <RouterProvider router={router} />
      <GlobalAlert />
    </CoreConfigProvider>
  );
};
